import { Modal, Spin } from 'antd';
import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import { getRandomCotation } from 'utils/methods/math';
import { useUI } from 'store/UI/selectors';
const btnpurple="rgba(86,29,223)"
var quata_change_interval =null;

const TextAuthor= styled.span`
    color:#fff;
    font-size: 14px;
    font-weight: 400;
    align-self: center;
    text-align: right;
    background-color: ${btnpurple};
    border-radius: 12px;
    padding: 2px 24px;
    margin-top:10px;
    min-width:100px;
    `;

const TextContainer = styled.div`
    display: flex;
    flex-direction:column;
    justify-content:center;
    align-items: flex-end;
    width: 100%;
    padding: 0px 16px;
`;
const MessageWrapper = styled.div `
    max-width:450px;
    padding: 10px;
`
const TextMessage = styled.span`
    color:#fff;
    font-size: 18px;
    font-weight: 600;

    @media (max-width: 992px) {
        font-size: 14px;
    }
`;
const QuetaArea = styled.div`
    // background: #3c1262;
    background-image: linear-gradient(to right, #510a49, #042f72) !important;
    width: auto;
    margin: 0 auto;
    text-align: center;
    padding: 12px 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 120px;
    border-radius: 56px;
    // &:hover {
    //     background-image: linear-gradient(to right, #510a49, #042f72) !important;
    // }
`;
const CognateAiLoader = ({ 
    aiModal, 
 }) => {
    const { quotesData = [] } = useUI();
    const [quatation,setQuatation] = useState(getRandomCotation(quotesData));
  
    useEffect(() => {
        if (quata_change_interval) {
            clearInterval(quata_change_interval);
        }
        quata_change_interval = setInterval(() => {
            setQuatation(getRandomCotation(quotesData))
        }, 6000);
        return () => clearInterval(quata_change_interval);
    }, [])

    return (
        <div>
            <Modal open={aiModal}
                className={`scenMdlWrapCstm scenarioMdlWrapNew gmScenarioSecond`}
                closable={false}
            >
                <div className='yourMagic'>
                    <div className='yourMagicImg'>
                        <img
                            src={'https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/AI_Topic.png?alt=media&token=e1a09441-0c55-4be0-a545-d0a579f8d7222'}
                            alt=''
                        />
                    </div>
                    <QuetaArea>
                        <TextContainer smallmsg={quatation?.size === "sml"} longAuthor={quatation?.author === "Selena Quintanilla-Pérez, cantante y compositora"}>
                            <MessageWrapper>
                                <TextMessage className='animate__animated animate__pulse'>{quatation?.message}</TextMessage>
                            </MessageWrapper>
                            {quatation?.author && <TextAuthor longAuthor={quatation?.author === "Selena Quintanilla-Pérez, cantante y compositora"} >- {quatation?.author}</TextAuthor>}
                        </TextContainer>
                    </QuetaArea>
                    <div className='maginSpinner'>
                        <Spin
                            size='large'
                            indicator={
                                <div className='magicIndicator'>
                                    <div className='dot' />
                                    <div className='dot' />
                                    <div className='dot' />
                                    <div className='dot' />
                                </div>
                            }
                        />
                    </div>
                </div>
            </Modal>
        </div>
    )
}
export default CognateAiLoader;